import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import getPlan from '../../src/apollo/graphql/plan/get';
import createContext from '../../src/utils/format/createContext';
import { Container } from '../../src/components/Grid';
import BlockImage from '../../src/components/Block/BlockImage';
import useMobile from '../../src/utils/useMobile';
import OpeningBadge from '../../src/components/Badge/OpeningBadge';
import ButtonWithLine from '../../src/components/Button/ButtonWithLine';

const ImageWrapper = styled.div`
  padding-top: 82px;
  margin-bottom: 50px;
`;

const Wrapper = styled.div`
  position: relative;
`;

const BagdeWrapper = styled.div`
  position: absolute;
  top: -80px;
  left: 70%;
`;

const ButtonWrapper = styled.div`
  margin-bottom: 50px;
`;

const BasicMap = ({ i18n, t }) => {
  const { isMobile } = useMobile();

  return (
    <Query query={getPlan} context={createContext(i18n.language)}>
      {({ loading, error, data }) => {
        if (
          !loading &&
          !error &&
          data &&
          data?.getPlan &&
          data?.getPracticalInfo
        ) {
          const plan = data.getPlan;
          const hours = JSON.parse(data.getPracticalInfo?.tt_hours);

          return (
            <Container>
              <Wrapper>
                <BagdeWrapper>
                  <OpeningBadge hours={hours} />
                </BagdeWrapper>
                <ImageWrapper>
                  <BlockImage
                    src={plan.image}
                    height={isMobile ? 300 : 600}
                    objectFit="contain"
                    withZoom
                  />
                </ImageWrapper>
              </Wrapper>
              {plan?.google_maps_url && (
                <ButtonWrapper>
                  <ButtonWithLine href={plan.google_maps_url}>
                    {t('plan.button.googlemaps')}
                  </ButtonWithLine>
                </ButtonWrapper>
              )}
            </Container>
          );
        }
        return null;
      }}
    </Query>
  );
};

BasicMap.propTypes = {
  i18n: PropTypes.object,
  t: PropTypes.object
};

export default translate()(BasicMap);
